import React, { Component } from 'react';
import { Input, Spinner } from 'reactstrap';
import { Button, Alert } from 'reactstrap';
import { AppContext } from '../AppContext';
import { RiFileUploadLine } from 'react-icons/ri';
import { AiOutlineReload } from 'react-icons/ai';
import { GiCancel, GiConfirmed } from 'react-icons/gi';
import { HiDocumentDownload, HiDocumentText } from 'react-icons/hi';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './NavMenu.css';
import url from "./variables/url.js";
/*import history from "../history";*/

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const localFront = process.env.REACT_APP_FRONT;
const homepage = process.env.REACT_APP_EXP;
const urlFileService = process.env.REACT_DOWNLOAD_FILE;
const MySwal = withReactContent(Swal);

export class AddActExtracurricular extends Component {
    static displayName = AddActExtracurricular.name;

    constructor(props) {
        super(props);
        this.state = {
            /*estructura registro actividad*/
            edit: false,
            matriz: false,
            admin: false,
            loading: true,
            valueInst: false,
            alertInst: false,
            idUser:0,
            actividad: {
                idaexregistroactividad: 0,
                categoria: 1,
                idaextipoactividad: 2,
                descripcionact: '',
                nombre: '',
                anio: '',
                horas: 0,
                evidencia: '',
                descripcionevid: '',
                tutor: '',
                puesto: '',
                contacto: '',
                instacredita: 2,
                idinstitucion: 2,                
                idestudiante: 0,
                revisado: 0,
                institucion: {
                    idaexentidad: 0 ,
                    nombre: 'ESPOL',
                    clasificacion: 'ESPOL',
                }
            },            
            gestion: {
                idaexregistroactividad: 0,
                idresponsable: 0,
                comentarios: '',
                estado: 'I ',                
            },
            persona: {
                idpersona: 0,
                numeroidentificacion: "",
                apellidos: "",
                nombres: "",
                codestudiante: "",
                email: "",
                sexo: "",
                estadopersona: "A",
                tipodiscapacidad: "N",
                tipoidentificacion: "CED",
                estadoempleado: "",
                tienediscapacidad: "N",
                tienefamildiscapacidad: "N"
            },            
            insignias: [],
            tipos: [],
            instituciones: [],
            institucionesSelect: [],
            institucionesInternas: [{ 'value': 'UNIDAD', 'label': 'Unidad' }, { 'value': 'ASOCIACION', 'label': 'Asociaci\u00F3n' }, { 'value': 'CLUBES', 'label': 'Clubes' }, { 'value': 'FEDERACION', 'label': 'Federaci\u00F3n' }/*, { 'value': 'ESPOL', 'label': 'INTERNO', disabled: true  }*/],
            selectedInstInterna: { 'value': 'UNIDAD', 'label': 'Unidad' },
            currentUser: [],
            classInstitucion: [{ 'value': 2, 'label': 'ESPOL' }, { 'value': 'EXTERNA', 'label': 'Externa' }],
            selectedClassInst: { 'value': 2, 'label': 'ESPOL' },
            selectedInst: { },
            radio: 'L',
            file: undefined,
            fileName: undefined,
            ArchivoEstado: [{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }, { cod: 'G', nombre: 'GOOD' }, { cod: 'B', nombre: 'BAD' }],
            fileState: 'N',
        };        

        // This binding is necessary to make "this" work in the callback        
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChangeCategoria = this.onChangeCategoria.bind(this);
        this.onChangeTipo = this.onChangeTipo.bind(this);
        this.onChangeInst = this.onChangeInst.bind(this);
        this.onChangeClassInst = this.onChangeClassInst.bind(this);
        this.oncodChange = this.oncodChange.bind(this);
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
    }

    componentDidMount() {
        //alert("hola");
        setTimeout(() => {
            let currentUser = this.context;
            if (currentUser !== null) {
                this.setState({ idUser: currentUser.idpersona });

                var actid = this.props.match.params["id"];
                var cat = this.props.match.params["categoria"];
                var tip = this.props.match.params["tipo"];

                if (actid > 0) {
                    this.setState({ loading: true, edit: true });
                    this.populateActividadData(actid, currentUser.idpersona);
                }
                if (cat > 0 && tip > 0) {
                    this.setState({ loading: true, matriz: true });
                    this.populateCategoriaTipoData(cat, tip);
                }
            }
            this.populateInfoData();
        }, 100);   
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser !== null && this.state.idUser === 0) {
            this.setState({ idUser: currentUser.idpersona });

            var actid = this.props.match.params["id"];
            var cat = this.props.match.params["categoria"];
            var tip = this.props.match.params["tipo"];            

            if (actid > 0) {
                this.setState({ loading: true, edit: true });
                this.populateActividadData(actid, currentUser.idpersona);
            }
            if (cat > 0 && tip > 0) {
                this.setState({ loading: true, matriz: true });
                this.populateCategoriaTipoData(cat, tip);
            }            
        }       
    }

    handleSave(event) {
        /*console.log("Crear");*/
        let forma = new FormData(event.target);
        let registro = this.state.actividad;
        let gestion = this.state.gestion;
        let mensaje = 'Su actividad fue ingresada';
        forma.forEach((value, clave) => {
            if (typeof registro[clave] === 'number') {
                registro[clave] = Number(value);
            }
            else if (typeof registro[clave] === 'boolean') {
                /*console.log(Boolean(value));*/

                registro[clave] = Boolean(value);
            }
            else if (value == '') {
                registro[clave] = null;
            }
            else {
                registro[clave] = value;
            }
        });        
        /*I para Ingresado, A para Aprobado y R para Rechazado.*/
        if (this.state.admin) {
            gestion.estado = "A";
            gestion.comentarios = "Actividad registrada y aprobada en el sistema.";
            gestion.idresponsable = 2567;
        } else {
            gestion.estado = "I";
            gestion.comentarios = "Actividad registrada en el Sistema.";
            gestion.idresponsable = registro.idestudiante;            
        }        
        registro.registroactividadgestion = gestion;
        if (!this.state.valueInst && this.usoInstitucion(registro.idaextipoactividad)) {
            this.setState({ alertInst: true });
        } else {
            this.setState({ alertInst: false });
            if (this.state.actividad.idaexregistroactividad > 0) {
                const data = JSON.stringify(registro);
                mensaje = 'Su actividad fue editada.';
                //console.log(data);
                fetch(localBack + '/api/RegistroActividad/PutWithGestion/' + this.state.actividad.idaexregistroactividad, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then((response) => response.json())
                    .then(data => {
                        if (data.strEstado === "S") {
                            MySwal.fire({
                                icon: 'success',
                                title: 'Solicitud Editada',
                                text: mensaje,
                                confirmButtonText: 'Listo',
                                /*timer: 5000*/
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.gotActividades();
                                }
                            })
                        } else {
                            MySwal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Error al editar Actividad',
                                confirmButtonText: 'salir',
                                /*timer: 5000*/
                            })
                        }
                    });

            }
            // POST.  
            else {
                //console.log(registro);
                const data = JSON.stringify(registro);

                fetch(localBack + '/api/RegistroActividad/PostWithGestion', {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                }).then((response) => response.json())
                    .then(data => {
                        //console.log(data);
                        if (data.strEstado === "S") {
                            MySwal.fire({
                                icon: 'success',
                                title: 'Solicitud ingresada',
                                text: mensaje,
                                confirmButtonText: 'Listo',
                                /*timer: 5000*/
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.gotActividades();
                                }
                            })
                        } else {
                            MySwal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Error al generar Actividad',
                                confirmButtonText: 'salir',
                                /*timer: 5000*/
                            })
                        }
                    });
            }
        }                     
        event.preventDefault();
    }

    gotActividades() {
        this.props.history.push(homepage+'Act-Est');
    }

    handleCancel() {
        //console.log("Cancelar");
        /*history.push("/Act-Est");*/
        this.props.history.push(homepage + "Act-Est");
    }

    handleSubir() {        
        /*/api/FileUpload / DescargarEvidencia / 684694*/
        this.setState({ fileState: 'L' });
        const formData = new FormData();
        formData.append("formFile", this.state.file);
        formData.append("fileName", this.state.fileName);
        if (this.state.fileName.toLowerCase().endsWith('.pdf')) {
            try {
                fetch(localBack + "/api/FileUpload/CargarEvidencia", { method: 'POST', body: formData })
                    .then(response => response.json())
                    .then(data => {
                        //console.log(data);
                        if (data.strEstado === "S") {
                            let dto = this.state.actividad;
                            let id = data.objDatos;
                            let a = id.split('/');
                            dto.evidencia = 'https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/' + a[a.length - 1] + '/' + a[a.length - 1] + ".pdf";
                            this.setState({ fileState: 'G', actividad: dto });
                            document.getElementById("evidencia").value = dto.evidencia;
                            //console.log(dto);
                        } else {
                            this.setState({ fileState: 'B' });
                        }
                    });

            } catch (ie) {
                this.setState({ fileState: 'B' });
                //console.log("Error: " + ie);
            }
        }
        else
        {
            this.setState({ fileState: 'B' });
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Se requiere documentos de tipo pdf',
                confirmButtonText: 'cerrar',
                /*timer: 5000*/
            })
        }
        
        
    }

    oncodChange(event) {
        var cod = event.target.value;
        var per = this.state.persona;                
        per.codestudiante = cod;
        this.setState({ persona: per });        
        //console.log(this.state.persona);        
    }

    onChangeFile(e) {        
        //console.log(this.state.fileName);
        //console.log(this.state.file);
        //console.log(e.target.files[0]);
        //console.log(e.target.files[0].name);
        this.setState({ file: e.target.files[0], fileName: e.target.files[0].name })
    }

    onChangeCategoria(event) {
        //console.log('Cambio Categoria');
        //console.log(event.target.value);
        var id = event.target.value;
        var dto = this.state.actividad;
        dto.categoria = id;
        this.setState({ actividad: dto });                 
        fetch(localBack + '/api/TipoActividad/categoria/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                this.setState({
                     tipos: data.objDatos, loading: false
                });
            });        
    }

    getPdf(link) {
        let a = link.split('/');
        let id = a[a.length - 1];
        let enlace = localFront + homepage + 'Descargar/'+ id;
        window.open(enlace, '_blank', 'noopener,noreferrer');
    }

    openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    abrirDoc(link) {
        if (link !== null) {
            if (link.startsWith(localBack + '/api/FileUpload/DescargarEvidencia/') || link.startsWith(localFront + homepage + 'Descargar/')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    onChangeRadio(event) {
        //console.log('Cambio Evi');
        //console.log(event.target.value);
        var id = event.target.value;
        this.setState({ radio: id });        
    }


    onChangeTipo(e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var id = e.target.value;
        var dto = this.state.actividad;
        dto.idaextipoactividad = id;
        this.setState({ actividad: dto });
    }

    onChangeInst = (selectedOption) => {
        var dto = this.state.actividad;
        const { value, label } = selectedOption;
        if (!isNaN(value)) {
            dto.institucion.idaexentidad = value;
        } else {
            dto.institucion.idaexentidad = 0;
        }
        dto.institucion.nombre = label;
        this.setState({
            actividad: dto,
            valueInst: true,
            alertInst: false,
            selectedInst: selectedOption
        });        
    };

    onChangeInstInterna = (selectedOption) => {
        var dto = this.state.actividad;
        const { value, label } = selectedOption;        
        let elect = this.state.instituciones.filter(i => i.clasificacion === value)[0];
        //console.log(elect);
        dto.institucion.nombre = elect.nombre;
        dto.institucion.clasificacion = value;
        this.setState({
            actividad: dto,
            selectedInstInterna: selectedOption,
            valueInst: false,
            selectedInst: {}
        });
    };

    onChangeClassInst = (selectedOption) => {
        var dto = this.state.actividad;
        var interna = { 'value': 'UNIDAD', 'label': 'Unidad' }
        const { value, label } = selectedOption;                
        if (label === 'Externa') {           
            dto.institucion.clasificacion = 'EXTERNA';
            /*dto.institucion.nombre = elect.label;*/
            dto.institucion.siglas = '';            
        } else {
            dto.institucion.clasificacion = 'UNIDAD';
            /*dto.institucion.nombre = elect.label;*/
            dto.institucion.siglas = '';            
        }
        this.setState({
            actividad: dto,
            selectedClassInst: selectedOption,
            selectedInstInterna: interna,
            selectedInst: {},
            valueInst: false
        });        
    };

    onlyNumber = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };

    renderAddActividadTable(insignias, actividad, tipos, instituciones) { 
        //let cortar = this.state.actividad.evidencia.split('/');
        //let total = cortar.length;
         return (
             <div className="col-md-12">                 
                 {this.state.edit ?

                     this.state.actividad.registroActividadGestion.estado != "I" ?
                         <Alert color={this.state.actividad.registroActividadGestion.estado === "I" ? "success" : this.state.actividad.registroActividadGestion.estado == "D" ? "warning" : this.state.actividad.registroActividadGestion.estado == "A" ? "primary" : this.state.actividad.registroActividadGestion.estado == "R" ? "danger" : "dark"}>
                             <h4 className="alert-heading" style={{ marginLeft: '0px' }}>{this.state.actividad.registroActividadGestion.estado == "D" ? "Devuelto: " : this.state.actividad.registroActividadGestion.estado == "A" ? "Aprobado: " : this.state.actividad.registroActividadGestion.estado == "R" ? "Rechazado: " : "Ingresado"}</h4>
                             <p>
                                 {this.state.actividad.registroActividadGestion.comentarios}
                             </p>
                         </Alert>                             
                         : <></>
                  : <></>}
            <form className="col-md-12" onSubmit={this.handleSave} >
                <Input type="hidden" name="idaexregistroactividad" value={this.state.actividad.idaexregistroactividad} />
                <Input type="hidden" name="idestudiante" value={this.state.actividad.idestudiante} />
                <Input type="hidden" name="revisado" value={this.state.actividad.revisado} />              
                     
                <div className="form-group row" >
                    <label className="control-label col-md-2" htmlFor="Name">Competencia: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeCategoria} value={this.state.actividad.categoria} disabled={this.state.matriz ? 'disabled' : 'disabled'}>
                        {insignias.map(insignia =>
                            <option key={insignia.idaexinsignia} selected={insignia.idaexinsignia == this.state.actividad.categoria ? true : false} value={insignia.idaexinsignia}>{insignia.nombre}</option>
                            )
                        }
                         </Input>
                </div>                
                <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Tipo: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeTipo} value={this.state.actividad.idaextipoactividad} disabled={this.state.matriz ? 'disabled' : 'disabled'}>
                        {tipos.map(tipo =>
                            <option key={tipo.idaextipoactividad} selected={tipo.idaextipoactividad == this.state.actividad.idaextipoactividad ? true : false} value={tipo.idaextipoactividad}>{tipo.nombre}</option>
                        )
                        }
                    </Input>
                </div>
                <div className="form-group row" >
                    <label className="control-label col-md-5" htmlFor="Name">Descripci&oacute;n Actividad:</label>
                    <Input type="textarea" rows="3" name="descripcionact" defaultValue={this.state.actividad.descripcionact} readOnly={this.state.matriz ? 'readOnly' : ''} required />
                </div>
                <div className="form-group row" >
                     <label className="control-label col-md-2" htmlFor="Name">{this.nombrePorTipo(this.state.actividad.idaextipoactividad)} </label>
                     <Input className="form-control col-md-10" type="text" name="nombre" defaultValue={this.state.actividad.nombre} required />
                </div>
                <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">A&ntilde;o: </label>
                         <Input className="form-control col-md-4" type="text" name="anio" onKeyPress={this.onlyNumber} defaultValue={this.state.actividad.anio} required />
                         {this.usoHora(this.state.actividad.idaextipoactividad)
                             ? <>< label className="control-label col-md-1" htmlFor="Name">Horas: </label>
                                 <Input className="form-control col-md-4" type="text" name="horas" onKeyPress={this.onlyNumber} defaultValue={this.state.actividad.horas} required /></>
                        : <></>}
                </div>                
                <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Evidencia: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeRadio} value={this.state.radio} disabled={this.state.fileState === 'G' ? '' : ''}>
                             <option key={'evi-L'} selected={this.state.radio === 'L' ? true : false} value={'L'}>Link</option>
                             <option key={'evi-A'} selected={this.state.radio === 'A' ? true : false} value={'A'}>Archivo</option>                             
                         </Input>
                </div>
                <div className="form-group row" hidden={this.state.radio !== 'L'}>
                         <label className="control-label col-md-2" htmlFor="Name">Link: </label>
                         <Input id={'evidencia'} className="form-control col-md-8" type="text" name="evidencia" defaultValue={this.state.actividad.evidencia} required />
                         {/*<div className="form-group row" hidden={!this.state.edit}>*/}
                             {this.state.actividad.evidencia !== '' ? this.abrirDoc(this.state.actividad.evidencia)
                                 ? <Button className="btn-info btn-round" onClick={() => this.getPdf(this.state.actividad.evidencia)} ><HiDocumentDownload /></Button>
                                 : this.state.actividad.evidencia === '' ? <></> : <Button className="btn-info btn-round" onClick={() => this.openInNewTab(this.state.actividad.evidencia)} ><HiDocumentText /></Button> : <></>}
                         {/*</div>*/}
                </div>
                <div className="form-group row" hidden={this.state.radio !== 'A'}>
                         <label className="control-label col-md-2" htmlFor="Name">Archivo: </label>
                         <Input className="form-control col-md-6" type="file" name="archivo" accept=".pdf" onChange={this.onChangeFile} disabled={this.state.fileState === 'L' ? 'disabled' : ''} />
                         <Button className="btn-info btn-round col-md-2" onClick={() => this.handleSubir()} disabled={this.state.fileState === 'L' ? 'disabled' : ''} >{this.state.fileState === 'N' ? <RiFileUploadLine /> : this.state.fileState === 'L' ? <Spinner animation="grow" size='sm' /> : <AiOutlineReload />}</Button>
                         <label className="control-label col-md-2" htmlFor="Name">{this.state.fileState === 'G' ? <><GiConfirmed /> Good</> : this.state.fileState === 'B' ? <><GiCancel /> Bad</> : this.state.fileState === 'L' ? 'Loading...' : <></>}</label>
                     </div>

                     

                     <div className="form-group row" >
                         {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                             <>
                                <label className="control-label col-md-2" htmlFor="Name">Tipo Instituci&oacute;n: </label>
                                <Select className="col-md-4" isSearchable={false} value={this.state.selectedClassInst} onChange={this.onChangeClassInst} options={this.state.classInstitucion} />
                             </>
                             : <></>}
                     </div>
                     <div className="form-group row" >
                         {this.usoTutor(this.state.actividad.idaextipoactividad) ?
                             <><label className="control-label col-md-1" htmlFor="Name"> {this.tutorPorTipo(this.state.actividad.idaextipoactividad)} </label>
                                 <Input className="form-control col-md-4" type="text" name="tutor" defaultValue={this.state.actividad.tutor} required /></>
                             : <></>}
                     </div>
                     {this.state.selectedClassInst.label === 'ESPOL' ? 
                         <div className="form-group row" >
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                    <label className="control-label col-md-2" htmlFor="Name">Clasificaci&oacute;n: </label>
                                    <Select className="col-md-4" isSearchable={false} value={this.state.selectedInstInterna} onChange={this.onChangeInstInterna} options={this.state.institucionesInternas} />
                                 </>
                                 : <></>}
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                     <label className="control-label col-md-2" htmlFor="Name">Instituci&oacute;n: </label>
                                     <Select className="col-md-4" value={this.state.selectedInst} onChange={this.onChangeInst} options={instituciones.filter(i => i.clasificacion === this.state.selectedInstInterna.value)} />
                                 </>
                                 : <></>}
                         </div>
                         :
                         <div className="form-group row" >
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                    <label className="control-label col-md-2" htmlFor="Name">Instituci&oacute;n: </label>
                                    <CreatableSelect isClearable className="col-md-4" formatCreateLabel={userInput => `Seleccionar ${userInput}` } value={this.state.selectedInst} onChange={this.onChangeInst} options={instituciones.filter(i => i.clasificacion === 'EXTERNA')} />
                                 </>
                                 : <></>}

                             {
                                 <><label className="control-label col-md-2" htmlFor="Name">Correo: </label>
                                   <Input className="form-control col-md-4" type="email" name="contacto" defaultValue={this.state.actividad.contacto} required /></>
                             }
                         </div>
                     }

                     {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                         <label hidden={!this.state.alertInst} style={{ color: 'red' }}>* Seleccione una Instituci&oacute;n</label>
                         : <></>
                     }
                     
                     {this.usoPuesto(this.state.actividad.idaextipoactividad)
                      ? < div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Puesto: </label>
                         <Input className="form-control col-md-4" type="text" name="puesto" defaultValue={this.state.actividad.puesto} required />
                       </div> : <></>}
                <div className="form-group row" >
                    <label className="control-label col-md-5" htmlFor="Name">Descripci&oacute;n Evidencia:</label>
                    <Input type="textarea" rows="3" name="descripcionevid" defaultValue={this.state.actividad.descripcionevid} required />
                </div>

                <div className="form-group row menu">
                    <label className=" control-label col-md-6" htmlFor="Name"></label>
                    <div className="col-md-6">
                        <Button className="btn-info btn-round" type='submit'>Guardar</Button>
                        &nbsp;&nbsp;&nbsp;                        
                        <Button className="btn-warning btn-round" onClick={this.handleCancel}>Cancelar</Button>
                    </div>
                </div >
             </form>
          </div>
        );
    }

    render() {
        const currentUser = this.context;
        if (currentUser == null) {
            return <><Spinner animation="grow" /></>;
        } else if (currentUser != null && this.state.idUser == 0) {
            this.setState({ idUser: currentUser.idpersona })
            this.populateActividadData(this.props.match.params["id"]);
        }
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderAddActividadTable(this.state.insignias, this.state.actividad, this.state.tipos, this.state.instituciones);

        let titulo = this.state.edit ? 'Editar Actividad Extracurricular' : 'Nueva Actividad Extracurricular';

        return (
            <div>
                <h1 id="tabelLabel" >{titulo}</h1>
                {contents}
            </div>
        );
    }    

    populateActividadData(id, idUser) {
        let instSel = {};
        let instClassSel = {};
        let instInternaSel = { 'value': 'UNIDAD', 'label': 'Unidad' };
        fetch(localBack + '/api/RegistroActividad/GetWithGestion/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    instSel = this.state.instituciones.filter(i => i.value === data.objDatos.idinstitucion);                    
                    if (data.objDatos.institucion.clasificacion === 'EXTERNA') {                        
                        instClassSel = { 'value': 'EXTERNA', 'label': 'Externa' };
                    } else {                      
                        instClassSel = { 'value': 2, 'label': 'ESPOL' };
                        instInternaSel = this.state.institucionesInternas.filter(i => i.value === data.objDatos.institucion.clasificacion);
                    }                    
                    this.setState({
                        actividad: data.objDatos,
                        loading: false,
                        total: 1,
                        selectedInst: instSel,
                        valueInst: true,
                        selectedClassInst: instClassSel,
                        selectedInstInterna: instInternaSel,
                    });
                    if (idUser > 0 && data.objDatos.idestudiante !== idUser) {
                        this.isForbidden();
                    } else if (idUser > 0 && data.objDatos.registroActividadGestion.estado !== 'D') {
                        this.isForbidden();
                    }
                } else {
                    this.setState({ loading: false });
                }
                //console.log(this.state.instituciones);
                //console.log(this.state.selectedClassInst);
            });        
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }    

    nombrePorTipo(tipo) {
        if (tipo === 1 || tipo === 13 || tipo === 16 || tipo === 25)
            return 'Nombre del Proyecto: '
        else if (tipo === 2 || tipo === 3)
            return 'Nombre del Reto: '
        else if (tipo === 5 || tipo === 8 || tipo === 14 || tipo === 17 || tipo === 19 || tipo === 27 || tipo === 28 || tipo === 29)
            return 'Nombre del Curso: '
        else if (tipo === 20)
            return 'Nombre de la Materia: '
        else if (tipo === 21)
            return 'Nombre de la Unidad: '
        else if (tipo === 10 || tipo === 12)
            return 'Nombre del Cargo: '
        else if (tipo === 26)
            return 'Nombre del Deporte: '
        else if (tipo === 22)
            return 'Mentoring Edici\u00F3n: '
        else if (tipo === 23)
            return 'Nombre del Torneo: '
        else
            return 'Nombre de Actividad: '
    }

    tutorPorTipo(tipo) {        
        if (tipo === 22)
            return 'Mentor: '
        else
            return 'Tutor: '
    }

    usoTutor(tipo) {
        let ids = [1, 22]
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoHora(tipo) {
        let ids = [1, 2, 3, 5, 8, 9, 10, 12, 13, 14, 17, 19, 20, 21, 22, 23, 26, 27, 28, 29, 31, 32];
        if (ids.includes(tipo))
            return false;
        else
            return true;
    }

    usoPuesto(tipo) {
        let puesto = [23];
        let respuesta = false;
        if (puesto.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoInstitucion(tipo) {
        let ids = [1,2,3,5,6,8,9,13,14,16,17,19,22,23,24,25,27,28,29];
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    populateCategoriaTipoData(categoria, tipo) {
        //console.log("Categoria " + categoria);
        //console.log("Tipo " + tipo);
        let tipoid = [];        
        let act = this.state.actividad;        
        fetch(localBack + '/api/TipoActividad/' + tipo, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data.objDatos);
                tipoid = data.objDatos;
                act.categoria = categoria;
                act.idaextipoactividad = tipoid.idaextipoactividad;
                act.descripcionact = tipoid.descripcionact;
                act.idestudiante = this.state.idUser;
                this.setState({
                    actividad: act,
                    loading: false,                     
                });                
            });
    }

    populateInfoData() {
        let ids = [];
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
            .then(data => {
                /*console.log(data.strMensaje);*/
                    this.setState({
                        insignias: data.objDatos  });
                });

        fetch(localBack + '/api/TipoActividad/GetOnlyActive', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos,
                    loading: false
                });
            });

        fetch(localBack + '/api/Entidad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {                
                data.objDatos.map(inst => { ids.push({ 'value': inst.idaexentidad, 'label': inst.nombre, 'clasificacion': inst.clasificacion }) });                
                this.setState({
                    instituciones: ids,
                    institucionesSelect: ids,
                    loading: false
                });                
            });        
        
    }

    actualizarInstitutos(texto) {
        let ids = [];
        
        fetch(localBack + '/api/Entidad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {                
                data.objDatos.filter(d => d.nombre.includes(texto)).map(inst => { ids.push({ 'value': inst.idaexentidad, 'label': inst.nombre }) });
                this.setState({
                    institucionesSelect: ids,
                    loading: false
                });
            });
        
    }
    
}
AddActExtracurricular.contextType = AppContext;